import OrderFailure from './OrderFailure'
export default OrderFailure
